<donut-datepicker v-model="startDate" format="mm/dd/yyyy"></donut-datepicker>